import type { SVGProps } from 'react';

const IgnoreIconAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_14440_174323)">
      <path
        d="M6.66675 9.9974H13.3334M18.3334 9.9974C18.3334 14.5998 14.6025 18.3307 10.0001 18.3307C5.39771 18.3307 1.66675 14.5998 1.66675 9.9974C1.66675 5.39502 5.39771 1.66406 10.0001 1.66406C14.6025 1.66406 18.3334 5.39502 18.3334 9.9974Z"
        stroke="#6C737F"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14440_174323">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IgnoreIconAlert;
